import { IPrice } from '../../../../common/model/IPrice';

const carPriceCalculator = {
  getTotalPayable: (price: IPrice, servicePlanValue: number, depositValue: number) => {
    const newPrice: IPrice = { ...price };

    newPrice.basePrice = price?.basePrice + (servicePlanValue || 0) - (depositValue || 0);

    return newPrice;
  },
};

export default carPriceCalculator;
